import { render, staticRenderFns } from "./m-square.vue?vue&type=template&id=6a579e0b&scoped=true"
import script from "./m-square.vue?vue&type=script&lang=js"
export * from "./m-square.vue?vue&type=script&lang=js"
import style0 from "./m-square.vue?vue&type=style&index=0&id=6a579e0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a579e0b",
  null
  
)

export default component.exports